import { defineStore } from 'pinia'
import axios from 'axios'

// Uwaga: w trybie session-cookie NIE przechowujemy tokenów w localStorage.
// "Zalogowany" = backend potwierdzi to przez /api/auth/me (cookie JSESSIONID).

export const useAuthStore = defineStore('auth', {
  state: () => ({
    ready: false,            // czy próbowaliśmy już ustalić stan sesji
    isAuthenticated: false,
    user: null,              // { id, email }
    roles: [],               // ['ADMIN', ...]
    adminPinRequired: false,
    adminPinUnlocked: true,
    permissions: {
      canUseAdminPanel: false,
      canAddToCart: true,
      canUseClientPanel: true,
    }
  }),
  actions: {
    setProfile(payload) {
      const p = payload || {}
      this.user = { id: p.id ?? null, email: p.email ?? '' }
      this.roles = Array.isArray(p.roles) ? p.roles : []
      this.adminPinRequired = !!p.adminPinRequired
      this.adminPinUnlocked = !this.adminPinRequired || !!p.adminPinUnlocked
      this.permissions = {
        canUseAdminPanel: !!p.canUseAdminPanel,
        canAddToCart: p.canAddToCart !== false,
        canUseClientPanel: p.canUseClientPanel !== false,
      }
      this.isAuthenticated = !!(this.user?.email)
      this.ready = true
    },

    clear() {
      this.ready = true
      this.isAuthenticated = false
      this.user = null
      this.roles = []
      this.adminPinRequired = false
      this.adminPinUnlocked = true
      this.permissions = {
        canUseAdminPanel: false,
        canAddToCart: true,
        canUseClientPanel: true,
      }
    },

    async bootstrap() {
      if (this.ready) return
      try {
        const { data } = await axios.get('/api/auth/me')
        this.setProfile(data)
        // upewnij się, że cookie XSRF-TOKEN jest ustawione (potrzebne dla POST/PUT/DELETE)
        try { await axios.get('/api/auth/csrf') } catch {}
        // Nowe otwarcie lub odświeżenie aplikacji wymaga ponownego wejścia PIN-em.
        if (this.adminPinRequired && this.adminPinUnlocked) await this.lockAdminPanel()
      } catch {
        this.clear()
      }
    },

    async logout() {
      // jeżeli backend ma /api/auth/logout - wywołaj; jeśli nie, to i tak czyścimy stan
      try { await axios.post('/api/auth/logout') } catch { }
      this.clear()
    },

    async unlockAdminPanel(pin) {
      await axios.post('/api/auth/admin-pin/unlock', { pin })
      this.adminPinUnlocked = true
    },

    async lockAdminPanel() {
      try { await axios.post('/api/auth/admin-pin/lock') } catch { }
      this.adminPinUnlocked = false
    },

    hasRole(...roles) {
      const list = Array.isArray(this.roles) ? this.roles : []
      return roles.some(r => list.includes(r))
    },

    hasAnyRole(roles) {
      const list = Array.isArray(this.roles) ? this.roles : []
      const want = Array.isArray(roles) ? roles : []
      return want.some(r => list.includes(r))
    }
  },
  // brak persist: po refresh odtwarzamy stan przez /api/auth/me
})
